import { render, staticRenderFns } from "./AufgabenPersonen.vue?vue&type=template&id=711b0237&scoped=true"
import script from "./AufgabenPersonen.vue?vue&type=script&lang=js"
export * from "./AufgabenPersonen.vue?vue&type=script&lang=js"
import style0 from "./AufgabenPersonen.vue?vue&type=style&index=0&id=711b0237&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b0237",
  null
  
)

export default component.exports